module.exports = __webpack_public_path__ + "static/media/roble_millenium.63f0b40b.jpg";